// 是否为藏剑心法
function isCangJian(mount){
    return mount == '10144' || mount == '10145'
}

export {isCangJian}